import React from "react";
import { Badge } from "react-bootstrap";
import Tooltip from "../tooltip/Tooltip";
import { useNavigate } from "react-router-dom";

export function NewTabBadge(props) {

  const navigate = useNavigate();

  return <Tooltip tooltip={props.tooltip}
                  placement={props.placement || "bottom"}

  >
    <Badge
      {...props}
      variant={props.variant || "primary"}
      onClick={() => props.sameTabUtl
        ? navigate(props.sameTabUtl)
        : window.open(props.newTabUrl, "_blank")}
      className={"cursor-pointer " + props.className}>
      {props.children}
    </Badge></Tooltip>;
}